import  classnames from 'classnames'
import { format as formatDate } from 'date-fns'
import {
  find,
  pathOr,
  propEq,
  take
} from 'ramda'
import React,
{
  useEffect,
  useMemo,
  useState
} from 'react'
import ReactDOM from 'react-dom'

import { Button } from '@driftt/tide-core'
import ObjectList from 'components/ObjectList'
import { useContactProperties } from 'hooks/useContactProperties'
import { isObject } from 'utils'
import {
  resolvePropertyLabel,
  resolvePropertyValue
} from 'utils/contactProperties'

import './style.css'

const MergeTool = ({
  email,
  isFetching = true,
  previewError,
  mergedContact = {},
  references = [],
  duplicates = [],
  unusedDuplicates = [],
  isSuccess,
  isLoading
}) => {
  const [totalDupesShown, setTotalDupesShown] = useState(10)
  const [hasLoaded, setHasLoaded] = useState(false)
  const [contactProperties] = useContactProperties()
  const propertyResolver = useMemo(() => resolvePropertyValue(contactProperties), [contactProperties])
  const labelResolver = useMemo(() => resolvePropertyLabel(contactProperties), [contactProperties])

  const allDupes = [...duplicates, ...unusedDuplicates]
  const visibleDupes = take(totalDupesShown, allDupes)
  const moreToLoad = allDupes.length !== visibleDupes.length
  const $tableEl = document.querySelector('.crm-merge-tool-table-wrapper table')

  useEffect(() => {
    if(isSuccess && !hasLoaded) {
      setTimeout(() => {
        setHasLoaded(true)
      }, 0)
    }

    if(isLoading) {
      setHasLoaded(false)
    }
  }, [isSuccess, hasLoaded, isLoading])

  const loadMore = () => {
    setTotalDupesShown(totalDupesShown + 10)
  }

  return(
    <>
    <div className={
      classnames("crm-merge-tool-table-wrapper", { "crm-merge-tool-table-wrapper--load-more": moreToLoad })}
    >
      <ObjectList
        tableClassName="crm-merge-preview-table"
        className="crm-merge-preview-table-inner"
        paginationDisabled
        isLoading={isFetching}
        initialLoadingText={<>Generating merge preview for <br /> {email}</>}
        error={previewError}
        data={references.length ? { results: references } : null}
        defaultCellClassNameResolver={(record, reference) => {
          return reference.end_user_id === record ? 'crm-merge-tool-merged-property' : null
        }}
        selectedColumns={(visibleDupes ?? []).map((dupe, index) => ({
          label: (
            <span>
              <small className="crm-merge-table-header-sub-label">
                {`Last updated ${formatDate((dupe.attributes.last_active ?? dupe.createdAt), 'MM/dd/yyyy')}`}
              </small>
            </span>
          ),
          value: dupe.id,
          className: 'crm-duplicates-list-contact-column',
          sortable: false,
        })) ?? []}
        propertyResolver={( value, reference ) => {
          const property = reference.path[1] ?? reference.path[0]
          const record = find(propEq('id', value), visibleDupes)
          const val = pathOr('--',
            reference.path,
            record)

          const parsedVal = isObject(val)
            ? JSON.stringify(val)
            : val

          if(!record) {
            return (
              <div className="crm-duplicates-list-merged-contact-column">
                <strong>
                  {labelResolver(property)}
                </strong>
                <span>{propertyResolver(property, mergedContact, parsedVal)}</span>
              </div>
            )
          }

          return propertyResolver(property, record, parsedVal)

        }}
        primaryColumns={[{
          label: <span>Merged contact</span>,
          value: null,
          className: 'crm-duplicates-list-name-column',
          customKey: `crm-column-name-primary`,
          sortable: false,
          primary: true
        }]}
      />
    </div>
    {/*
      this is a bit of a hack - intentionally doing some invalid dom nesting,
      but I could not figure out how to position the button correctly in the
      internal scroll container otherwise. as of jan 21 this is still not out to customers
      and its unclear wether or not we will be showing the addt columns at all once
      we do some customer validation.
     */}
    {(hasLoaded && moreToLoad && $tableEl) && (
      ReactDOM.createPortal((
        <Button
          onClick={loadMore}
          type="tertiary"
          className="crm-merge-tool-load-more">Show more
        </Button>
      ),
      $tableEl)
    )}
    </>
  )
}

export default MergeTool
